import type { GQL } from '@aline/graphql';
import type { BaseElement } from 'slate';

import type { UUID } from '../../../types/type-helpers';
import type {
  AlineTextFormats,
  CheckboxOptionFieldElement,
  DateFieldElement,
  DateFieldProps,
  DropdownFieldElement,
  DropdownFieldProps,
  NumberFieldElement,
  NumberFieldProps,
  RadioButtonFieldElement,
  RadioButtonFieldProps,
  SignatureFieldElement,
  SignatureFieldProps,
  SuggestedEdit,
  TextFieldElement,
  TextFieldProps,
} from '../../internal';

export type InputFieldType = 'INPUT';
export const inputFieldType: InputFieldType = 'INPUT';

export interface InputFieldElementInterface extends BaseElement {
  // A UUID for linking copies of an input field together in a document and for tying to server/DB data.
  fieldId: UUID;
  type: InputFieldType;
  variant: GQL.FieldVariant;
  formats?: AlineTextFormats;
  suggestedEdits?: SuggestedEdit[] | null;
}

export type NonSigFieldElement =
  | CheckboxOptionFieldElement
  | DateFieldElement
  | DropdownFieldElement
  | NumberFieldElement
  | RadioButtonFieldElement
  | TextFieldElement;

export type InputFieldElement = NonSigFieldElement | SignatureFieldElement;

export type NonSigFieldProps =
  | TextFieldProps
  | NumberFieldProps
  | DateFieldProps
  | DropdownFieldProps
  | RadioButtonFieldProps;
export type InputFieldProps = NonSigFieldProps | SignatureFieldProps;
